import React, { useEffect, useState, useRef, useCallback } from 'react'
import { Icon, Hidden, MenuItem, Button } from '@material-ui/core'
import {
    MatxMenu,
    MatxToolbarMenu,
    MatxSearchBox,
    MatxDivider,
} from 'app/components'
import styled from 'styled-components'
import ShoppingCart from 'app/components/ShoppingCart/ShoppingCart'
import { makeStyles } from '@material-ui/core/styles'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import useSettings from 'app/hooks/useSettings'
import useAuth from 'app/hooks/useAuth'
import { useHistory, useLocation } from 'react-router-dom'
import { getCountryFromUrl } from 'utils/CountryUtils'
import { devices } from 'utils/screen_sizes'
import PhoneNumberDrawer from 'app/components/SideDrawer/PhoneNumberDrawer'
import MenuDrawer from './Drawer'
import { useTranslation } from 'react-i18next'

const StyledTopBar = styled.div`
    background-color: #fff;
    /* color: #fff; */
    display: grid;
    grid-template-columns: 1fr 3fr 1fr;
    align-items: center;

    span {
        display: flex;
        align-items: center;
    }

    button {
        color: #42c8b7;
    }

    .px-7 {
        color: #fff;
        background-color: #42c8b7;
    }

    .search-bar {
        grid-column: span 3;
    }

    @media ${devices.laptop} {
        padding: 0.8rem 2rem;
        display: grid;
        grid-template-columns: 0.8fr 2fr 1fr 0.2fr;
    }
`
const useStyles = makeStyles(({ palette, ...theme }) => ({
    root: {
        backgroundColor: '#2b313d',
        backgroundSize: 'cover',
        borderBottom: '1px solid transparent',

        zIndex: 45,
        paddingLeft: '1rem',
        paddingRight: '1rem',
        [theme.breakpoints.down('sm')]: {
            padding: '1rem',
        },
    },

    menuItem: {
        minWidth: 60,
        display: 'flex',
        alignItems: 'center',
    },
}))
const StyledMobileLogo = styled.img`
    width: 100px;

    @media ${devices.laptop} {
    }
`
const StyledUserSpan = styled.span`
    display: flex;
    flex-direction: row;
    justify-content: end;

    button {
        color: #fff;
    }
`
const StyledUser = styled.div`
    display: flex;

    div,
    span {
        line-height: normal;
        margin: auto 0.2rem;
    }

    span {
        cursor: pointer;
    }
`
const MobileUserMenu = styled.div`
    div {
        color: #555 !important;
    }

    @media ${devices.laptop} {
        display: none;
    }
`
const StyledMobileLogoLink = styled(Link)`
    justify-content: center;
    @media ${devices.laptop} {
        margin-right: 4rem;
    }
`
const StyledMenuSpan = styled.span`
    display: flex;
    flex-direction: row;
    align-items: center;

    button {
        color: #000;
    }
`
const StyledRelativeWrapper = styled.div`
    grid-column: span 3;
`
const CountrySelector = styled.select`
    background: #fff;
    border: 1px solid #fff;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    box-shadow: none;
    font-size: 14px;
    margin: 0 1rem;

    @media ${devices.mobileS} {
        border: 1px solid #42c8b7;
    }
    @media ${devices.laptop} {
        border: 1px solid #fff;
    }
`
const PrimaryNavbar = ({ page = 'buyback' }) => {
    const { pathname } = useLocation()
    let country = getCountryFromUrl(pathname) || 'ke'
    const classes = useStyles()
    const { settings, updateSettings } = useSettings()
    const { logout, user = {}, isAuthenticated } = useAuth()
    const history = useHistory()
    const [drawerOpen, setDrawerOpen] = useState(false)
    const [panelOpen, setPanelOpen] = useState(false)
    const [shopifyNewURl, setShopifyNewURl] = useState('')
    const [nextPath, setNextPath] = useState(`/`)
    // Split the pathname by "/"
    const parts = pathname.split('/')
    // Get the last two parts and join them with "/"
    const extractedPath = `/${parts[parts.length - 2]}/${
        parts[parts.length - 1]
    }`
    //console.log(extractedPath) // Output: "/retailer/register"
    const { t, i18n } = useTranslation()

    // const changeLanguage = () => {
    //     if (window.location.hostname === 'localhost') {
    //         i18n.changeLanguage('sw');
    //     }
    // };
    const languages = [{ name: 'English' }, { name: 'Swahili' }]
    const handleChangeLanguage = (e) => {
        const selectedLanguage = e.target.value
        localStorage.setItem('language', selectedLanguage)

        if (selectedLanguage === 'Swahili') {
            i18n.changeLanguage('sw')
        } else if (selectedLanguage === 'English') {
            i18n.changeLanguage('en')
        }
    }
    const updateSidebarMode = (sidebarSettings) => {
        updateSettings({
            layout3Settings: {
                leftSidebar: {
                    ...sidebarSettings,
                },
            },
        })
    }
    useEffect(() => {
        if (window.location.hostname === 'sell.badili.ke') {
            setShopifyNewURl('https://badili.ke/')
        } else if (window.location.hostname === 'sell.badili.co.tz') {
            setShopifyNewURl('https://badili.co.tz/')
        } else if (window.location.hostname === 'sell.badili.ug') {
            setShopifyNewURl('https://badili.ug/')
        } else {
            setShopifyNewURl('https://badili.ke/')
        }
    }, [])
    const handleSidebarToggle = () => {
        setDrawerOpen(true)
        const { layout3Settings } = settings
        const mode =
            layout3Settings.leftSidebar.mode === 'close' ? 'mobile' : 'close'
        updateSidebarMode({ mode })
    }

    const handleDrawerToggle = (_nextPath = `/${country}|` || 'ke') => {
        setPanelOpen(!panelOpen)
        setNextPath(_nextPath)
        return panelOpen
    }
    // const drawerRef = useRef(null)
    // const handleClickOutside = useCallback((event) => {
    //     setDrawerOpen(true)
    // })
    // const handleClickOutside = useCallback((event) => {
    //
    //     setDrawerOpen(true);
    // }, [drawerRef]);
    // // useEffect(() => {
    // //     window._toggleDrawer = handleDrawerToggle;
    // //     document.addEventListener('mousedown', handleClickOutside);
    // //     return () => {
    // //         document.removeEventListener('mousedown', handleClickOutside);
    // //     };
    // // }, [handleDrawerToggle, handleClickOutside]);
    const handleLogOut = () => {
        try {
            logout()
            history.push(pathname)
        } catch (e) {}
    }
    return (
        <StyledTopBar
            className={clsx('relative w-full', classes.root)}
            //page={page}
        >
            <Hidden mdDown>
                <span>
                    <MatxToolbarMenu
                        offsetTop="64px"
                        handleSidebarToggle={handleSidebarToggle}
                    >
                        {panelOpen && (
                            <PhoneNumberDrawer
                                page={page}
                                panelOpen={panelOpen}
                                handleDrawerToggle={handleDrawerToggle}
                                nextPath={nextPath}
                            />
                        )}
                    </MatxToolbarMenu>
                    {/* old code */}
                    {/* <StyledMobileLogoLink
                        className={classes.menuItem}
                        to={
                            page === 'ecommerce'
                                ? `/${country || 'ke'}/ecommerce/shop`
                                : `/${country || 'ke'}`
                        }
                    > */}
                    {extractedPath === '/retailer/register' ? (
                        <a
                            className={classes.menuItem}
                            href={shopifyNewURl}
                        >
                            <StyledMobileLogo
                                src={'/assets/images/logo-orange.svg'}
                            />
                        </a>
                    ) : (
                        <a
                            className={classes.menuItem}
                           // to={{pathname:shopifyNewURl }}
                           href={shopifyNewURl}  // Ensure shopifyNewURL is correctly defined
                           rel="noopener noreferrer"  // Recommended for security reasons when using target="_blank"

                        >
                            <StyledMobileLogo
                                src={
                                    page === 'ecommerce'
                                        ? '/assets/images/logo-orange.svg'
                                        : '/assets/images/logo-green.svg'
                                }
                            /> 
                        </a>
                    )}
                </span>

                <div className="p-relative">
                    <MatxSearchBox />
                </div>

                <StyledUserSpan>
                    <div style={{ marginLeft: '28px' }}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                        >
                            <path
                                d="M12 22C10.6333 22 9.34167 21.7373 8.125 21.212C6.90833 20.6867 5.84567 19.97 4.937 19.062C4.029 18.154 3.31233 17.0917 2.787 15.875C2.26167 14.6583 1.99933 13.3667 2 12C2 10.6167 2.26267 9.32067 2.788 8.112C3.31333 6.90333 4.03 5.84533 4.938 4.938C5.846 4.02933 6.908 3.31267 8.124 2.788C9.34 2.26333 10.632 2.00067 12 2C13.3833 2 14.6793 2.26267 15.888 2.788C17.0967 3.31333 18.1547 4.03 19.062 4.938C19.9707 5.846 20.6873 6.90433 21.212 8.113C21.7367 9.32167 21.9993 10.6173 22 12C22 13.3667 21.7373 14.6583 21.212 15.875C20.6867 17.0917 19.97 18.1543 19.062 19.063C18.154 19.971 17.0957 20.6877 15.887 21.213C14.6783 21.7383 13.3827 22.0007 12 22ZM12 19.95C12.4333 19.35 12.8083 18.725 13.125 18.075C13.4417 17.425 13.7 16.7333 13.9 16H10.1C10.3 16.7333 10.5583 17.425 10.875 18.075C11.1917 18.725 11.5667 19.35 12 19.95ZM9.4 19.55C9.1 19 8.83734 18.429 8.612 17.837C8.38667 17.245 8.19934 16.6327 8.05 16H5.1C5.58333 16.8333 6.18767 17.5583 6.913 18.175C7.63833 18.7917 8.46733 19.25 9.4 19.55ZM14.6 19.55C15.5333 19.25 16.3627 18.7917 17.088 18.175C17.8133 17.5583 18.4173 16.8333 18.9 16H15.95C15.8 16.6333 15.6127 17.246 15.388 17.838C15.1633 18.43 14.9007 19.0007 14.6 19.55ZM4.25 14H7.65C7.6 13.6667 7.56234 13.3373 7.537 13.012C7.51167 12.6867 7.49933 12.3493 7.5 12C7.5 11.65 7.51267 11.3127 7.538 10.988C7.56333 10.6633 7.60067 10.334 7.65 10H4.25C4.16667 10.3333 4.104 10.6627 4.062 10.988C4.02 11.3133 3.99933 11.6507 4 12C4 12.35 4.021 12.6873 4.063 13.012C4.105 13.3367 4.16733 13.666 4.25 14ZM9.65 14H14.35C14.4 13.6667 14.4377 13.3373 14.463 13.012C14.4883 12.6867 14.5007 12.3493 14.5 12C14.5 11.65 14.4873 11.3127 14.462 10.988C14.4367 10.6633 14.3993 10.334 14.35 10H9.65C9.6 10.3333 9.56233 10.6627 9.537 10.988C9.51167 11.3133 9.49933 11.6507 9.5 12C9.5 12.35 9.51267 12.6873 9.538 13.012C9.56333 13.3367 9.60067 13.666 9.65 14ZM16.35 14H19.75C19.8333 13.6667 19.896 13.3373 19.938 13.012C19.98 12.6867 20.0007 12.3493 20 12C20 11.65 19.979 11.3127 19.937 10.988C19.895 10.6633 19.8327 10.334 19.75 10H16.35C16.4 10.3333 16.4377 10.6627 16.463 10.988C16.4883 11.3133 16.5007 11.6507 16.5 12C16.5 12.35 16.4873 12.6873 16.462 13.012C16.4367 13.3367 16.3993 13.666 16.35 14ZM15.95 8H18.9C18.4167 7.16667 17.8127 6.44167 17.088 5.825C16.3633 5.20833 15.534 4.75 14.6 4.45C14.9 5 15.1627 5.571 15.388 6.163C15.6133 6.755 15.8007 7.36733 15.95 8ZM10.1 8H13.9C13.7 7.26667 13.4417 6.575 13.125 5.925C12.8083 5.275 12.4333 4.65 12 4.05C11.5667 4.65 11.1917 5.275 10.875 5.925C10.5583 6.575 10.3 7.26667 10.1 8ZM5.1 8H8.05C8.2 7.36667 8.38767 6.754 8.613 6.162C8.83833 5.57 9.10067 4.99933 9.4 4.45C8.46667 4.75 7.63733 5.20833 6.912 5.825C6.18667 6.44167 5.58267 7.16667 5.1 8Z"
                                fill="#181818"
                            />
                        </svg>
                    </div>
                    <CountrySelector
                        className="form-control"
                        name="language"
                        value={localStorage.getItem('language') || ''}
                        style={{ margin: '0rem' }}
                        placeholder=""
                        onChange={handleChangeLanguage}
                    >
                        {languages.map((language, i) => (
                            <option value={language.name} key={i}>
                                {language.name}
                            </option>
                        ))}
                    </CountrySelector>

                    <MobileUserMenu>
                        {isAuthenticated && user && user.signupComplete && (
                            <MatxMenu menuButton={<Icon>person</Icon>}>
                                <MenuItem className={classes.menuItem}>
                                    <Link
                                        className={classes.menuItem}
                                        to={`/${
                                            country || 'ke'
                                        }/device-details`}
                                    >
                                        <span className="pl-4">
                                            {' '}
                                            Track Your Order{' '}
                                        </span>
                                    </Link>
                                </MenuItem>
                                <MatxDivider />
                                <MenuItem>
                                    <Link
                                        className={classes.menuItem}
                                        to={`/${country || 'ke'}/orders`}
                                    >
                                        <span className="pl-4"> Orders </span>
                                    </Link>
                                </MenuItem>
                                <MatxDivider />
                                <MenuItem
                                    onClick={handleLogOut}
                                    className={classes.menuItem}
                                >
                                    <span className="pl-4"> Sign out </span>
                                </MenuItem>
                            </MatxMenu>
                        )}
                        {(!isAuthenticated || !user.signupComplete) && (
                            <MatxMenu menuButton={<Icon>person</Icon>}>
                                <MenuItem
                                    onClick={() =>
                                        handleDrawerToggle(
                                            `/${country || 'ke'}`
                                        )
                                    }
                                    className={classes.menuItem}
                                >
                                    <span className="pl-4">
                                        {' '}
                                        Sign In / Sign Up{' '}
                                    </span>
                                </MenuItem>
                                <MatxDivider />
                                <MenuItem
                                    onClick={() =>
                                        handleDrawerToggle(`/${country}`)
                                    }
                                    className={classes.menuItem}
                                >
                                    <span className="pl-4">
                                        {' '}
                                        Track Your Order{' '}
                                    </span>
                                </MenuItem>
                            </MatxMenu>
                        )}
                    </MobileUserMenu>

                    {isAuthenticated && user && user.signupComplete && (
                        <StyledUser>
                            <ShoppingCart cartcolor="#000" label={false} />
                            <MatxMenu menuButton={<Icon>person</Icon>}>
                                <MenuItem>
                                    <Link
                                        className={classes.menuItem}
                                        to={`/${country}/orders`}
                                    >
                                        <Icon> event_note </Icon>
                                        <span className="pl-4">Orders </span>
                                    </Link>
                                </MenuItem>
                                <MatxDivider />
                                <MenuItem
                                    onClick={handleLogOut}
                                    className={classes.menuItem}
                                >
                                    <Icon> power_settings_new </Icon>
                                    <span
                                        className="pl-4"
                                        style={{ color: '#000' }}
                                    >
                                        {' '}
                                        Sign out{' '}
                                    </span>
                                </MenuItem>
                            </MatxMenu>
                            {user?.fname && (
                                <span
                                    style={{
                                        fontSize: '13px',
                                        fontFamily: 'open-sans',
                                    }}
                                >
                                    {`Hi, ${user?.fname}`}
                                </span>
                            )}
                        </StyledUser>
                    )}

                    {(!isAuthenticated || !user.signupComplete) && (
                        <StyledUser>
                            <ShoppingCart cartcolor="#000" label={false} />
                            <MatxMenu menuButton={<Icon>person</Icon>}>
                                {' '}
                                <MenuItem
                                    onClick={() =>
                                        handleDrawerToggle(`/${country}`)
                                    }
                                    className={classes.menuItem}
                                >
                                    <span
                                        style={{ color: '#000' }}
                                        onClick={() =>
                                            handleDrawerToggle(`/${country}`)
                                        }
                                    >
                                        {' '}
                                        Sign In{' '}
                                    </span>
                                </MenuItem>
                                <MatxDivider />
                                <MenuItem
                                    onClick={() =>
                                        handleDrawerToggle(`/${country}`)
                                    }
                                    className={classes.menuItem}
                                >
                                    <span style={{ color: '#000' }}>
                                        {' '}
                                        Sign Up{' '}
                                    </span>
                                </MenuItem>
                            </MatxMenu>
                            <span
                                style={{
                                    fontSize: '13px',
                                    fontFamily: 'open-sans',
                                    color: '#000',
                                }}
                            >
                                <Button
                                    className="m-2  bg-primary px-6"
                                    variant="outlined"
                                    color="primary"
                                    onClick={() =>
                                        handleDrawerToggle(`/${country}`)
                                    }
                                    style={{ minInlineSize: 'max-content' }}
                                >
                                    {' '}
                                    {t('description.login')}
                                </Button>
                            </span>
                        </StyledUser>
                    )}
                </StyledUserSpan>
            </Hidden>
            <Hidden lgUp>
                <StyledMenuSpan>
                    <MatxToolbarMenu
                        offsetTop="64px"
                        handleSidebarToggle={handleSidebarToggle}
                    >
                        {drawerOpen && (
                            <>
                                <MenuDrawer
                                    page={page}
                                    drawerOpen={drawerOpen}
                                    setDrawerOpen={setDrawerOpen}
                                    handleDrawerToggle={handleDrawerToggle}
                                    nextPath={nextPath}
                                />
                                <div className="backdrop"></div>
                            </>
                        )}
                        {panelOpen && (
                            <>
                                <PhoneNumberDrawer
                                    page={page}
                                    panelOpen={panelOpen}
                                    handleDrawerToggle={handleDrawerToggle}
                                    nextPath={nextPath}
                                />
                                <div className="backdrop"></div>
                            </>
                        )}
                    </MatxToolbarMenu>
                </StyledMenuSpan>

                {/* old code */}
                {/* <StyledMobileLogoLink
                    className={classes.menuItem}
                    to="/ecommerce/shop"
                > */}
                {extractedPath === '/retailer/register' ? (
                    <a className={classes.menuItem} href={`https://badili.ke/`}>
                        <StyledMobileLogo
                            src={'/assets/images/logo-orange.svg'}
                        />
                    </a>
                ) : (
                    <>
                        {' '}
                        <a
                            className={classes.menuItem}
                            // to={{
                            //     pathname:
                            //         page === 'ecommerce'
                            //             ? `https://shop.badili.ke/`
                            //             : `/${country || 'ke'}`,
                            // }}
                            // to={{pathname:shopifyNewURl }}
                            href={shopifyNewURl}  // Ensure shopifyNewURL is correctly defined
                            rel="noopener noreferrer"  // Recommended for security reasons when using target="_blank"
                        
                        >
                            <StyledMobileLogo
                                src={
                                    page === 'ecommerce'
                                        ? '/assets/images/logo-orange.svg'
                                        : '/assets/images/logo-green.svg'
                                }
                            />
                        </a>
                    </>
                )}
                <StyledUserSpan>
                    {' '}
                    <div style={{ marginLeft: '28px' }}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                        >
                            <path
                                d="M12 22C10.6333 22 9.34167 21.7373 8.125 21.212C6.90833 20.6867 5.84567 19.97 4.937 19.062C4.029 18.154 3.31233 17.0917 2.787 15.875C2.26167 14.6583 1.99933 13.3667 2 12C2 10.6167 2.26267 9.32067 2.788 8.112C3.31333 6.90333 4.03 5.84533 4.938 4.938C5.846 4.02933 6.908 3.31267 8.124 2.788C9.34 2.26333 10.632 2.00067 12 2C13.3833 2 14.6793 2.26267 15.888 2.788C17.0967 3.31333 18.1547 4.03 19.062 4.938C19.9707 5.846 20.6873 6.90433 21.212 8.113C21.7367 9.32167 21.9993 10.6173 22 12C22 13.3667 21.7373 14.6583 21.212 15.875C20.6867 17.0917 19.97 18.1543 19.062 19.063C18.154 19.971 17.0957 20.6877 15.887 21.213C14.6783 21.7383 13.3827 22.0007 12 22ZM12 19.95C12.4333 19.35 12.8083 18.725 13.125 18.075C13.4417 17.425 13.7 16.7333 13.9 16H10.1C10.3 16.7333 10.5583 17.425 10.875 18.075C11.1917 18.725 11.5667 19.35 12 19.95ZM9.4 19.55C9.1 19 8.83734 18.429 8.612 17.837C8.38667 17.245 8.19934 16.6327 8.05 16H5.1C5.58333 16.8333 6.18767 17.5583 6.913 18.175C7.63833 18.7917 8.46733 19.25 9.4 19.55ZM14.6 19.55C15.5333 19.25 16.3627 18.7917 17.088 18.175C17.8133 17.5583 18.4173 16.8333 18.9 16H15.95C15.8 16.6333 15.6127 17.246 15.388 17.838C15.1633 18.43 14.9007 19.0007 14.6 19.55ZM4.25 14H7.65C7.6 13.6667 7.56234 13.3373 7.537 13.012C7.51167 12.6867 7.49933 12.3493 7.5 12C7.5 11.65 7.51267 11.3127 7.538 10.988C7.56333 10.6633 7.60067 10.334 7.65 10H4.25C4.16667 10.3333 4.104 10.6627 4.062 10.988C4.02 11.3133 3.99933 11.6507 4 12C4 12.35 4.021 12.6873 4.063 13.012C4.105 13.3367 4.16733 13.666 4.25 14ZM9.65 14H14.35C14.4 13.6667 14.4377 13.3373 14.463 13.012C14.4883 12.6867 14.5007 12.3493 14.5 12C14.5 11.65 14.4873 11.3127 14.462 10.988C14.4367 10.6633 14.3993 10.334 14.35 10H9.65C9.6 10.3333 9.56233 10.6627 9.537 10.988C9.51167 11.3133 9.49933 11.6507 9.5 12C9.5 12.35 9.51267 12.6873 9.538 13.012C9.56333 13.3367 9.60067 13.666 9.65 14ZM16.35 14H19.75C19.8333 13.6667 19.896 13.3373 19.938 13.012C19.98 12.6867 20.0007 12.3493 20 12C20 11.65 19.979 11.3127 19.937 10.988C19.895 10.6633 19.8327 10.334 19.75 10H16.35C16.4 10.3333 16.4377 10.6627 16.463 10.988C16.4883 11.3133 16.5007 11.6507 16.5 12C16.5 12.35 16.4873 12.6873 16.462 13.012C16.4367 13.3367 16.3993 13.666 16.35 14ZM15.95 8H18.9C18.4167 7.16667 17.8127 6.44167 17.088 5.825C16.3633 5.20833 15.534 4.75 14.6 4.45C14.9 5 15.1627 5.571 15.388 6.163C15.6133 6.755 15.8007 7.36733 15.95 8ZM10.1 8H13.9C13.7 7.26667 13.4417 6.575 13.125 5.925C12.8083 5.275 12.4333 4.65 12 4.05C11.5667 4.65 11.1917 5.275 10.875 5.925C10.5583 6.575 10.3 7.26667 10.1 8ZM5.1 8H8.05C8.2 7.36667 8.38767 6.754 8.613 6.162C8.83833 5.57 9.10067 4.99933 9.4 4.45C8.46667 4.75 7.63733 5.20833 6.912 5.825C6.18667 6.44167 5.58267 7.16667 5.1 8Z"
                                fill="#181818"
                            />
                        </svg>
                    </div>
                    <CountrySelector
                        className="form-control"
                        name="language"
                        value={localStorage.getItem('language') || ''}
                        placeholder=""
                        onChange={handleChangeLanguage}
                    >
                        {languages.map((language, i) => (
                            <option value={language.name} key={i}>
                                {language.name}
                            </option>
                        ))}
                    </CountrySelector>
                    <MobileUserMenu>
                        {isAuthenticated && user && user.signupComplete && (
                            <MatxMenu menuButton={<Icon>person</Icon>}>
                                <MenuItem className={classes.menuItem}>
                                    <Link
                                        className={classes.menuItem}
                                        to={`/${country}/device-details`}
                                    >
                                        <span className="pl-4">
                                            {' '}
                                            Track Your Order{' '}
                                        </span>
                                    </Link>
                                </MenuItem>
                                <MatxDivider />
                                <MenuItem>
                                    <Link
                                        className={classes.menuItem}
                                        to={`/${country}/orders`}
                                    >
                                        <span className="pl-4"> Orders </span>
                                    </Link>
                                </MenuItem>
                                <MatxDivider />
                                <MenuItem
                                    onClick={handleLogOut}
                                    className={classes.menuItem}
                                >
                                    <span className="pl-4"> Sign out </span>
                                </MenuItem>
                            </MatxMenu>
                        )}
                        {(!isAuthenticated || !user.signupComplete) && (
                            <MatxMenu menuButton={<Icon>person</Icon>}>
                                <MenuItem
                                    onClick={() =>
                                        handleDrawerToggle(`/${country}`)
                                    }
                                    className={classes.menuItem}
                                >
                                    <span> Sign In </span>
                                </MenuItem>
                                <MatxDivider />
                                <MenuItem
                                    onClick={() =>
                                        handleDrawerToggle(`/${country}`)
                                    }
                                    className={classes.menuItem}
                                >
                                    <span>Sign Up</span>
                                </MenuItem>
                            </MatxMenu>
                        )}
                    </MobileUserMenu>
                    <ShoppingCart cartcolor="#000" label={false} />
                </StyledUserSpan>
                <StyledRelativeWrapper>
                    <MatxSearchBox />
                </StyledRelativeWrapper>
            </Hidden>
        </StyledTopBar>
    )
}

export default PrimaryNavbar
